import { Component, Input } from '@angular/core';
import { CementingIcp } from 'src/app/interfaces/cementing';
import { HandoverService } from 'src/app/services/handover.service';

@Component({
  selector: 'app-handover-detail-cementing-icp',
  templateUrl: './handover-detail-cementing-icp.component.html',
  styleUrl: './handover-detail-cementing-icp.component.scss',
  standalone: false,
})
export class HandoverDetailCementingIcpComponent {
  @Input() handoverId: number | undefined;
  @Input() wellName: string | undefined;
  @Input() handoverStatusId: number | undefined;

  cementingsIcp: CementingIcp[] = [];
  isLoading = false;
  hideFooter = true;
  displayedColumns = ['startDate', 'top', 'base', 'result'];

  constructor(public handoverService: HandoverService) {}

  ngOnInit(): void {
    if (this.handoverId && this.wellName) {
      this.isLoading = true;
      this.handoverService
        .getCementingsIcp(
          this.handoverId,
          this.wellName!,
          this.handoverStatusId!
        )
        .subscribe((c: CementingIcp[]) => {
          if (c) {
            this.cementingsIcp = c;
            this.hideFooter = this.cementingsIcp!.length > 0;
          }
          this.isLoading = false;
        });
    }
  }
}
